module.exports = __webpack_public_path__ + "assets/img/ic-marquee.a8d71bcc.svg";